export default "__VITE_ASSET__d10b_NFI__"